// extracted by mini-css-extract-plugin
export default {"searchDoctors":"DoctorsInBranch_searchDoctors__geeNw","results":"DoctorsInBranch_results__1onFs","expend":"DoctorsInBranch_expend__6ow4l","show":"DoctorsInBranch_show__NwlcN"};